<div class="topbar-item theme-mode-toggle">
    <button type="button"
            [class]="customStyle + ' theme-mode-toggle__button'"
            (click)="toggleThemeMode()"
            [attr.aria-label]="toggleLabel"
            [pTooltip]="toggleLabel"
            tooltipPosition="bottom">
        <i class="theme-mode-toggle__icon" aria-hidden="true">
            <img *ngIf="isDarkMode" class="theme-mode-toggle__image" src="assets/common/images/header/theme-mode-sun.svg" alt="" />
            <img *ngIf="!isDarkMode" class="theme-mode-toggle__image" src="assets/common/images/header/theme-mode-moon.svg" alt="" />
        </i>
    </button>
</div>
